import { Controller } from "@hotwired/stimulus";
import Chart from "chart.js/auto";

export default class extends Controller {
  static values = {
    data: Object,
    options: Object,
    tooltipData: Array,
  };

  connect() {
    const tooltipOptions = this.hasTooltipDataValue
      ? this.tooltipOptions()
      : {};

    new Chart(this.element, {
      type: "line",
      data: this.dataValue,
      options: Object.assign(this.optionsValue, tooltipOptions),
    });
  }

  tooltipOptions() {
    const tooltipData = this.tooltipDataValue;

    return {
      plugins: {
        tooltip: {
          callbacks: {
            label: function (context) {
              let label = context.dataset.label;
              const crewIndex = context.datasetIndex;
              const monthIndex = context.dataIndex;

              if (label) {
                label += ": ";
              }
              if (
                tooltipData[crewIndex] !== null &&
                tooltipData[crewIndex][monthIndex] !== "0"
              ) {
                label += tooltipData[crewIndex][monthIndex];
              }

              return label;
            },
          },
        },
      },
    };
  }
}
